import useState from "react-usestateref";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import {
  AppBar,
  Drawer,
  ListItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import "./style.css";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const About = () => {
  const [menuopen, setMenuopn] = useState(false);
  const menuopenClose = () => {
    setMenuopn(true);
  };

  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <>
      {" "}
      <div className="main-bg about-bg">
        <section
          className={` ${
            menuopen === true ? "menuopenzindex" : "menuclosezindex"
          }`}
        >
          <header className="main-header scrolled header-wrapper">
            <AppBar position="static" className="header_secondsec">
              <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
                <div className="hd_navigation">
                  <div
                    className="d-flex hd_nav_lft"
                    onClick={handleAboutLogoClick}
                  >
                    <Link className="logo-wrapper">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                  </div>

                  <div className="hd_nav_links_cntr">
                    <Link
                      to="/about"
                      className={`hd_nav_link ${isActive("about")}`}
                    >
                      About
                    </Link>
                    <Link
                      to="/services"
                      className={`hd_nav_link ${isActive("services")}`}
                    >
                      Services
                    </Link>
                    <Link
                      to="/projects"
                      className={`hd_nav_link ${isActive("projects")}`}
                    >
                      Projects
                    </Link>
                    <Link
                      to="/testimonials"
                      className={`hd_nav_link ${isActive("testimonials")}`}
                    >
                      Testimonials
                    </Link>
                  </div>

                  <div className="rightside_menu">
                    <div className="header_btn_wrap">
                      <button
                        className="header-btn"
                        onClick={() => navigate("/contact-us")}
                      >
                        <span className="phone_icon">
                          <FaPhoneAlt />
                        </span>
                        <span>Contact</span>
                      </button>

                      <button
                        className="header-btn"
                        onClick={() =>
                          window.open(
                            "https://beleaftechnologies.com/",
                            "_blank"
                          )
                        }
                      >
                        <span className="web_icon">
                          <TbWorld />
                        </span>
                        <span className="">Website</span>
                      </button>
                    </div>

                    {/* <div className="menu_img" onClick={menuopenClose}>
                      <span className="hamburger-menu">
                        <i className="fa-solid fa-bars"></i>
                      </span>
                    </div> */}
                  </div>

                  <div className="header_bars" onClick={handleMobileMenuOpen}>
                    <i className="fa-solid fa-bars"></i>
                  </div>
                </div>
              </Toolbar>
            </AppBar>

            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
            >
              <div className={` ${classes.mobileMenu}`}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <div
                    className="mobile_logo_wrap"
                    onClick={handleAboutLogoClick}
                  >
                    <img src={Logo} alt="logo" />
                  </div>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/about">
                      About
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/services">
                      Services
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/projects">
                      Projects
                    </Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/testimonials">
                      Testimonials
                    </Link>
                  </ListItem> */}

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span>Contact</span>
                    </button>
                  </ListItem>

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </ListItem>
                </div>
              </div>
            </Drawer>
          </header>

          <main>
            <div className="header-wrapper section-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-6 ">
                    <div className="getting_card_content">
                      <span
                        className="getcard_sub_subhead padding-right"
                        data-aos="fade-left"
                      >
                        Who we are.
                      </span>
                      <h1 data-aos="fade-left">About beleaf</h1>
                      <p data-aos="fade-up" data-aos-delay="4000">
                        Beleaf Technologies is a leading blockchain development
                        service provider, specializing in creating advanced
                        blockchain solutions for businesses of all sizes.
                      </p>
                      <p data-aos="fade-up" data-aos-delay="4000">
                        Our team of experts is passionate about blockchain
                        technology and is dedicated to helping you support its
                        potential to the fullest. With years of experience and a
                        deep understanding of the blockchain, we are your
                        trusted partner in directing the complexities of this
                        extensive technology.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6"></div>
                </div>

                <div className="row get-in-touch-row">
                  <div className="col-lg-5">
                    <div
                      className="about-get-in-touch"
                      data-toggle="modal"
                      data-target="#myModal"
                      // data-aos="fade-left"
                    >
                      <p>Get in Touch</p>
                      <span onClick={() => navigate("/contact-us")}>
                        <IoMdCall />
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-7 aboutus_header">
                    <div className="clients-row">
                      <div className="col-lg-2">
                        <h2 className="clients-num">100+</h2>
                        <span className="border_services"></span>
                        <p className="happyclient_tag">
                          Happy <br /> clients
                        </p>
                      </div>
                      <div className="col-lg-2">
                        <h2 className="clients-num">150+</h2>
                        <span className="border_services"></span>
                        <p className="happyclient_tag">
                          Successful <br /> projects
                        </p>
                      </div>
                      <div className="col-lg-2">
                        <h2 className="clients-num">100+</h2>
                        <span className="border_services"></span>
                        <p className="happyclient_tag">
                          Countries <br /> served
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </section>
      </div>
    </>
  );
};

export default About;
